/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SaveAnnotationAdditionalContentRequest model module.
 * @module model/SaveAnnotationAdditionalContentRequest
 * @version 2.8.0
 */
class SaveAnnotationAdditionalContentRequest {
    /**
     * Constructs a new <code>SaveAnnotationAdditionalContentRequest</code>.
     * @alias module:model/SaveAnnotationAdditionalContentRequest
     */
    constructor() { 
        
        SaveAnnotationAdditionalContentRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SaveAnnotationAdditionalContentRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SaveAnnotationAdditionalContentRequest} obj Optional instance to populate.
     * @return {module:model/SaveAnnotationAdditionalContentRequest} The populated <code>SaveAnnotationAdditionalContentRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SaveAnnotationAdditionalContentRequest();

            if (data.hasOwnProperty('addedColumns')) {
                obj['addedColumns'] = ApiClient.convertToType(data['addedColumns'], [['String']]);
            }
            if (data.hasOwnProperty('addedColumnsProperties')) {
                obj['addedColumnsProperties'] = ApiClient.convertToType(data['addedColumnsProperties'], [Object]);
            }
            if (data.hasOwnProperty('knowledgeGraphResults')) {
                obj['knowledgeGraphResults'] = ApiClient.convertToType(data['knowledgeGraphResults'], [Object]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<Array.<String>>} addedColumns
 */
SaveAnnotationAdditionalContentRequest.prototype['addedColumns'] = undefined;

/**
 * @member {Array.<Object>} addedColumnsProperties
 */
SaveAnnotationAdditionalContentRequest.prototype['addedColumnsProperties'] = undefined;

/**
 * @member {Array.<Object>} knowledgeGraphResults
 */
SaveAnnotationAdditionalContentRequest.prototype['knowledgeGraphResults'] = undefined;






export default SaveAnnotationAdditionalContentRequest;

